import React, { useState } from "react";

function ITStaffing() {
  const [activeTab, setActiveTab] = useState("agility");
  const [candidateTab, setCandidateTab] = useState("candidateNeed");
  const [engageTab, setEngageTab] = useState("engage");
  const containerStyle = {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    minHeight: "500px",
    color: "white",
    marginTop: "40px"
  };

  const videoStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: 0,
  };

  const contentStyle = {
    zIndex: 1,
    position: "absolute",
    bottom: "0px",
    width: "100%",
  };
  return (
    <div class="container py-6">
      <div class="row" bis_skin_checked="1">
        <div
          class="col-md-5 elementor-element elementor-element-5bfdb9c e-con-full e-flex e-con e-child"
          data-id="5bfdb9c"
          data-element_type="container"
          bis_skin_checked="1"
        >
          <div
            class="elementor-element elementor-element-5a11fa2 elementor-widget elementor-widget-html"
            data-id="5a11fa2"
            data-element_type="widget"
            data-widget_type="html.default"
            bis_skin_checked="1"
          >
            <div class="elementor-widget-container" bis_skin_checked="1">
              <h2 class="text-3xl text-gray-900 font-semibold m-0">
                Benefits of Choosing
                <br />
                <span class="text-orange"> RevTech</span>
              </h2>
              <div class="mt-4" bis_skin_checked="1">
                <a href="#talentFulFillment" class="scroll-to-btn">
                  Scroll to Learn more
                </a>
              </div>{" "}
            </div>
          </div>
        </div>
        <div
          class="col-md-7 elementor-element elementor-element-3710406 e-con-full e-flex e-con e-child"
          data-id="3710406"
          data-element_type="container"
          bis_skin_checked="1"
        >
          <div
            class="elementor-element elementor-element-30f9f8b elementor-widget elementor-widget-html"
            data-id="30f9f8b"
            data-element_type="widget"
            data-widget_type="html.default"
            bis_skin_checked="1"
          >
            <div class="elementor-widget-container" bis_skin_checked="1">
              <p class="text-base text-gray-900">
                Access a diverse pool of pre-screened IT specialists with
                flexible staffing for short-term, long-term, or project needs.
                Enjoy quick hiring, expert guidance, and seamless onboarding
                throughout the hiring lifecycle.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div style={containerStyle}>
      <video
        style={videoStyle}
        autoPlay
        muted
        loop
        playsInline
      >
        <source
          src="https://algebrait.in/wp-content/uploads/2025/02/IT-Staffing-video.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div style={contentStyle}>
        <div className="videos-container it-solutions-video">
          <div className="secondary-menu-main">
            <div className="secondary-menu-container row">
              <div className="col-md-6 col-12 secondary-menu">
                <ul>
                  <li>
                    <a href="#talentFulFillment">Talent Fulfillment</a>
                  </li>
                  <li>
                    <a href="#talentAcquisition">Talent Acquisition</a>
                  </li>
                  <li>
                    <a href="#talentEngagement">Talent Engagement</a>
                  </li>
                </ul>
              </div>
              <div className="col-md-6 col-12">
                <div className="row secondary-menu-actions">
                  <a
                    className="col-md-6 link-btn-secondary mr-4"
                    href="#"
                    target="_blank"
                  >
                    Download Capability Statement
                  </a>
                  <a className="col-md-6 link-btn-primary" href="#">
                    Speak to our team
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
      <div
        class="elementor-element elementor-element-7b88c92 e-flex e-con-boxed e-con e-parent e-lazyloaded"
        data-id="7b88c92"
        data-element_type="container"
        id="talentFulFillment"
        bis_skin_checked="1"
      >
        <div class="e-con-inner row" bis_skin_checked="1">
          <div
            class="elementor-element elementor-element-89e5ac8 e-con-full e-flex e-con e-child col-md-6"
            data-id="89e5ac8"
            data-element_type="container"
            bis_skin_checked="1"
          >
            <div
              class="elementor-element elementor-element-fe4a3e1 elementor-widget elementor-widget-html"
              data-id="fe4a3e1"
              data-element_type="widget"
              data-widget_type="html.default"
              bis_skin_checked="1"
            >
              <div class="elementor-widget-container" bis_skin_checked="1">
                <h2 class="text-3xl text-gray-900 font-semibold m-0">
                  Talent<span class="text-orange"> Fulfillment</span>
                </h2>
                <p class="font-medium text-base text-gray-900 pt-3">
                  We start with development and implementation of our Talent
                  Fulfillment 3A.
                </p>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-e74fe32 e-con-full e-flex e-con e-child col-md-6"
            data-id="e74fe32"
            data-element_type="container"
            bis_skin_checked="1"
          >
            <div
              class="elementor-element elementor-element-c655a5b elementor-widget elementor-widget-html"
              data-id="c655a5b"
              data-element_type="widget"
              data-widget_type="html.default"
              bis_skin_checked="1"
            >
              <div class="elementor-widget-container" bis_skin_checked="1">
                <p class="text-base text-gray-900">
                  This foundational framework provides us with the Agility,
                  Adaptability, and Alignment needed to power easy and timely
                  access to exceptional talent: Vector Talent. From here, we
                  move on to acquire the talent that meets — and more than
                  likely — exceeds your expectations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="elementor-element elementor-element-246c540 e-flex e-con-boxed e-con e-parent e-lazyloaded"
        data-id="246c540"
        data-element_type="container"
        bis_skin_checked="1"
      >
        <div
          class="elementor-element elementor-element-097933c elementor-widget elementor-widget-html"
          data-id="097933c"
          data-element_type="widget"
          data-widget_type="html.default"
          bis_skin_checked="1"
        >
          <div className="elementor-widget-container">
            <div className="tabs-main row">
              <div className="col-md-4 col-12">
                <div className="tabs-menu">
                  <ul>
                    <li className={activeTab === "agility" ? "active" : ""}>
                      <a onClick={() => setActiveTab("agility")}>
                        Agility
                      </a>
                    </li>
                    <li
                      className={activeTab === "adaptability" ? "active" : ""}
                    >
                      <a onClick={() => setActiveTab("adaptability")}>
                        Adaptability
                      </a>
                    </li>
                    <li className={activeTab === "alignment" ? "active" : ""}>
                      <a onClick={() => setActiveTab("alignment")}>
                        Alignment
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-8 col-12 pl-5 pt-3">
                <div
                  id="agility"
                  className={`tab-content ${
                    activeTab === "agility" ? "d-block" : "d-none"
                  }`}
                >
                  <h4 className="text-2xl text-gray-900 font-semibold pb-2">
                    Empowering{" "}
                    <span className="text-orange">IT Workforce Agility</span>{" "}
                    Through Strategic Sourcing
                  </h4>
                  <p className="text-base text-gray-600 pb-3">
                    Ongoing and proactive strategic sourcing leads to agility.
                    This way, we initiate rapid-fire, on-demand fulfillment to
                    augment your IT workforce. This drives needed efficiencies
                    that support desired outcomes.
                  </p>
                </div>
                <div
                  id="adaptability"
                  className={`tab-content ${
                    activeTab === "adaptability" ? "d-block" : "d-none"
                  }`}
                >
                  <h4 className="text-2xl text-gray-900 font-semibold pb-2">
                    <span className="text-orange">
                      Adaptive Workforce Solutions
                    </span>{" "}
                    for a Dynamic Industry Landscape
                  </h4>
                  <p className="text-base text-gray-600 pb-3">
                    We monitor your ever-changing industry landscape, adapting
                    our workforce engagement and acquisition strategies
                    accordingly using the latest recruiting and communications
                    tools and technologies to drive these strategies. At the
                    ready, we work with you to provide flexible solutions that
                    enhance achievement at every level.
                  </p>
                </div>
                <div
                  id="alignment"
                  className={`tab-content ${
                    activeTab === "alignment" ? "d-block" : "d-none"
                  }`}
                >
                  <h4 className="text-2xl text-gray-900 font-semibold pb-2">
                    Building Success Through{" "}
                    <span className="text-orange">
                      Trust, Alignment, and Clear Communication
                    </span>
                  </h4>
                  <p className="text-base text-gray-600 pb-3">
                    With candid communication and trust, success is realistic
                    and attainable as we agree on our direction with clients.
                    Keeping our teams and related stakeholders on track and
                    aligned, we pull together as goals are met.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="elementor-element elementor-element-8645adc e-flex e-con-boxed e-con e-parent e-lazyloaded"
        data-id="8645adc"
        data-element_type="container"
        id="talentAcquisition"
        data-settings='{"background_background":"classic"}'
        bis_skin_checked="1"
      >
        <div class="e-con-inner row" bis_skin_checked="1">
          <div class="elementor-widget-container col-md-6" bis_skin_checked="1">
            <h2 class="text-3xl text-gray-900 font-semibold m-0">
              Talent<span class="text-orange"> Acquisition</span>
            </h2>
            <p class="font-medium text-base text-gray-900 pt-3">
              Talent Fulfillment 3A Framework &amp; 360 Recruiting Process
            </p>
          </div>

          <div class="elementor-widget-container col-md-6" bis_skin_checked="1">
            <p class="text-base text-gray-900">
              This holistic approach is used to craft and execute our talent
              sourcing strategy. It incorporates new/social media as well as
              traditional recruitment tools.
            </p>
          </div>
        </div>
      </div>

      <div className="elementor-widget-container">
      <div className="tabs-main row">
        <div className="col-md-4 col-12">
          <div className="tabs-menu">
            <ul>
              <li className={candidateTab === "candidateNeed" ? "active" : ""}>
                <a onClick={() => setCandidateTab("candidateNeed")}>Candidate Need</a>
              </li>
              <li className={candidateTab === "candidateQualification" ? "active" : ""}>
                <a onClick={() => setCandidateTab("candidateQualification")}>Candidate Qualification</a>
              </li>
              <li className={candidateTab === "candidateSubmission" ? "active" : ""}>
                <a onClick={() => setCandidateTab("candidateSubmission")}>Candidate Submission</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-8 col-12 pl-5 pt-3">
          <div id="candidateNeed" className={`tab-content ${candidateTab === "candidateNeed" ? "d-block" : "d-none"}`}>
            <h4 className="text-2xl text-gray-900 font-semibold pb-2">
              Strategic <span className="text-orange"> Candidate</span> Sourcing Process
            </h4>
            <p className="text-base text-gray-600 pb-3">
              Once your requirements are received and analyzed by your Vector Account Manager, a strategy is developed to seek out potential
              candidate pools for further screening by us. This is a two-step process:
            </p>
            <ul className="list-1">
              <li className="mb-2">Assess requirements internally for strategy development.</li>
              <li className="mb-2">Advertise the job to vendor partners and job boards.</li>
            </ul>
          </div>
          <div id="candidateQualification" className={`tab-content ${candidateTab === "candidateQualification" ? "d-block" : "d-none"}`}>
            <h4 className="text-2xl text-gray-900 font-semibold pb-2">
              Comprehensive <span className="text-orange"> Candidate</span> Aggregation Process
            </h4>
            <p className="text-base text-gray-600 pb-3">
              With sourcing underway, our dedicated team of recruiters begins aggregating candidates from numerous resources including
              Vector’s Applicant Tracking System (ATS). We skill-match more than 125,000 pre-sourced candidates for their professional and
              technical competencies. This is a three-step process:
            </p>
            <ul className="list-1">
              <li className="mb-2">Aggregate resumés from key sources.</li>
              <li className="mb-2">Pre-screen potential candidates.</li>
              <li className="mb-2">Identify qualified candidates.</li>
            </ul>
          </div>
          <div id="candidateSubmission" className={`tab-content ${candidateTab === "candidateSubmission" ? "d-block" : "d-none"}`}>
            <h4 className="text-2xl text-gray-900 font-semibold pb-2">
              Streamlined<span className="text-orange"> Candidate</span> Vetting &amp; Onboarding
            </h4>
            <p className="text-base text-gray-600 pb-3">
              Thoroughly vetted, cleaned, and standardized resumés of high-potential candidates are reviewed with the client. Once top
              candidate selections are made, we conduct comprehensive background and reference checks. Upon final candidate selection by the client,
              we provide customized on-boarding that includes a client orientation and client-side introductions. This two-step process includes:
            </p>
            <ul className="list-1">
              <li className="mb-2">Vet and submit resumés of top candidates for interview and selection.</li>
              <li className="mb-2">Manage candidate on-boarding and contract administration.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

      <div
        class="elementor-element elementor-element-8645adc e-flex e-con-boxed e-con e-parent e-lazyloaded"
        data-id="8645adc"
        data-element_type="container"
        id="talentEngagement"
        data-settings='{"background_background":"classic"}'
        bis_skin_checked="1"
      >
        <div class="e-con-inner row" bis_skin_checked="1">
          <div class="elementor-widget-container col-md-6" bis_skin_checked="1">
            <h2 class="text-3xl text-gray-900 font-semibold m-0">
              Talent<span class="text-orange"> Engagement</span>
            </h2>
            <p class="font-medium text-base text-gray-900 pt-3">
              Deploying Talent Engagement methodology after Talent Fulfillment
              3A &amp; Talent Acquisition 360.
            </p>
          </div>

          <div class="elementor-widget-container col-md-6" bis_skin_checked="1">
            <p class="text-base text-gray-900">
              Throughout every client engagement, we listen, provide feedback,
              encourage education and training, maintain competitive
              compensation, and recognize these individuals as talented and
              appreciated team members. Retention of our workforce talent is a
              top priority.
            </p>
          </div>
        </div>
        <div className="elementor-widget-container">
        <div className="tabs-main row">
          <div className="col-md-4 col-12">
            <div className="tabs-menu">
              <ul>
                <li className={engageTab === "engage" ? "active" : ""}>
                  <a onClick={() => setEngageTab("engage")}>Engage</a>
                </li>
                <li className={engageTab === "manage" ? "active" : ""}>
                  <a onClick={() => setEngageTab("manage")}>Manage</a>
                </li>
                <li className={engageTab === "communicate" ? "active" : ""}>
                  <a onClick={() => setEngageTab("communicate")}>Communicate</a>
                </li>
                <li className={engageTab === "learnReEngage" ? "active" : ""}>
                  <a onClick={() => setEngageTab("learnReEngage")}>Learn & Re-Engage</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-8 col-12 pl-5 pt-3">
            <div className={`tab-content ${engageTab === "engage" ? "d-block" : "d-none"}`}>
              <h4>Building Strong Client Partnerships</h4>
              <p>Engage focuses on building strong client relationships through active listening, understanding needs, and fostering collaboration. We prioritize open communication, trust, and aligning our services with your goals, ensuring a tailored approach to meet your unique requirements effectively.</p>
            </div>
            <div className={`tab-content ${engageTab === "manage" ? "d-block" : "d-none"}`}>
              <h4>Efficient Task Order Execution</h4>
              <p>Manage emphasizes streamlined task order management, ensuring timely deliverables, clear workflows, and adherence to project goals. Our focus is on optimizing resources, tracking progress, and maintaining transparency to drive successful outcomes and client satisfaction.</p>
            </div>
            <div className={`tab-content ${engageTab === "communicate" ? "d-block" : "d-none"}`}>
              <h4>Fostering Open Collaboration</h4>
              <p>Communicate centers on meaningful dialogue to enhance understanding, share insights, and address needs effectively. We prioritize transparency, active listening, and knowledge sharing to strengthen partnerships and ensure alignment with your objectives.</p>
            </div>
            <div className={`tab-content ${engageTab === "learnReEngage" ? "d-block" : "d-none"}`}>
              <h4>Continuous Improvement and Engagement</h4>
              <p>Learn & Re-Engage focuses on refining processes through feedback, quality management, and issue resolution. By analyzing outcomes and adapting strategies, we ensure ongoing alignment, compliance, and the delivery of exceptional results to support your mission.</p>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}

export default ITStaffing;
